import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    
    // Supprimer les espaces en début et fin
    value = value.trim();
    
    // Si la saisie est en cours (moins de 10 caractères pour DD/MM/YYYY), retourner null
    if (value.length < 10) return null;
    
    const parts = value.split('/');
    
    // Vérifier qu'on a bien 3 parties
    if (parts.length !== 3) return null;
    
    const day = +parts[0];
    const month = +parts[1];
    const year = +parts[2];
    
    // Valider que toutes les parties sont des nombres valides
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    
    // Valider les plages de valeurs
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
      return null;
    }
    
    return { day, month, year };
  }

  format(date: NgbDateStruct | null): string {
    if (
      !date ||
      date.day === null ||
      date.month === null ||
      date.year === null
    ) {
      return ''; // Retourne une chaîne vide uniquement si la date est complètement vide
    }
    return `${this.pad(date.day)}/${this.pad(date.month)}/${date.year}`;
  }

  private pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }
}

@Injectable()
export class CustomPennylaneAboDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    
    // Supprimer les espaces en début et fin
    value = value.trim();
    
    // Si la saisie est en cours (moins de 10 caractères pour DD/MM/YYYY), retourner null
    if (value.length < 10) return null;
    
    const parts = value.split('/');
    
    // Vérifier qu'on a bien 3 parties
    if (parts.length !== 3) return null;
    
    const day = +parts[0];
    const month = +parts[1];
    const year = +parts[2];
    
    // Valider que toutes les parties sont des nombres valides
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    
    // Valider les plages de valeurs
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
      return null;
    }
    
    return { day, month, year };
  }

  format(date: NgbDateStruct | null): string {
    if (
      !date ||
      date.day === null ||
      date.month === null ||
      date.year === null
    ) {
      return ''; // Retourne une chaîne vide uniquement si la date est complètement vide
    }
    return `${this.pad(date.day)}/${this.pad(date.month)}/${date.year}`;
  }

  private pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }
}
